import React, { useState, useRef } from 'react';
import FadeIn from '../../shared/FadeIn';

export const metadata = {
    id: 'reaction-test',
    title: 'Reaction Test',
    description: 'Test your reflexes! Click as soon as the color changes.',
    icon: '⚡', // Emoji or path to image
    color: 'purple' // Theme color
};

const ReactionTest = () => {
    const [status, setStatus] = useState('waiting'); // waiting, ready, click, result
    const [time, setTime] = useState(0);
    const timerRef = useRef(null);
    const startTimeRef = useRef(0);

    const startTest = () => {
        setStatus('ready');
        setTime(0);

        const randomDelay = Math.floor(Math.random() * 2000) + 1000;

        timerRef.current = setTimeout(() => {
            setStatus('click');
            startTimeRef.current = Date.now();
        }, randomDelay);
    };

    const handleClick = () => {
        if (status === 'ready') {
            clearTimeout(timerRef.current);
            setStatus('early');
        } else if (status === 'click') {
            const reactionTime = Date.now() - startTimeRef.current;
            setTime(reactionTime);
            setStatus('result');
        } else if (status === 'result' || status === 'early') {
            startTest();
        }
    };

    let bgColor = 'bg-gray-800';
    let text = 'Click to Start';

    if (status === 'ready') {
        bgColor = 'bg-red-600';
        text = 'Wait for Green...';
    } else if (status === 'click') {
        bgColor = 'bg-green-500';
        text = 'CLICK NOW!';
    } else if (status === 'result') {
        bgColor = 'bg-blue-600';
        text = `${time} ms`;
    } else if (status === 'early') {
        bgColor = 'bg-orange-500';
        text = 'Too Early! Click to Retry';
    }

    return (
        <FadeIn>
            <div className={`h-96 w-full rounded-2xl flex items-center justify-center cursor-pointer transition-colors duration-200 ${bgColor} select-none`}
                onMouseDown={handleClick}
            >
                <div className="text-center">
                    <h2 className="text-5xl font-black text-white drop-shadow-md mb-2">{text}</h2>
                    <p className="text-white/70">
                        {status === 'waiting' && '(Click anywhere to begin)'}
                    </p>
                </div>
            </div>

            {status === 'result' && (
                <div className="mt-8 text-center">
                    <button
                        onClick={() => setStatus('waiting')}
                        className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-white transition-colors"
                    >
                        Back to Menu
                    </button>
                </div>
            )}
        </FadeIn>
    );
};

export default ReactionTest;
